import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import packageJson from '../../../../../package.json'
import { AsyncPipe } from '@angular/common'
import { ContactCsm } from '../../../shared/models/contact-csm'
import { HeaderComponent } from '../header/header.component'

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [AsyncPipe, HeaderComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
    @Input({ required: true })
    backendVersion: string
    @Input({ required: true })
    shouldDisplayContactCSM = false
    @Input()
    contactCsm: ContactCsm
    version = packageJson.version

    @Input({ required: true })
    supportEmail: string
}
